import React, {useEffect} from 'react';
import Chart from 'react-apexcharts';
import { convertSubTagString } from 'utils/utils';
import { statusTypeStandardization } from 'utils/utils';
import { lineGraphReferenceValue } from 'utils/code';
import './LineGraph.css';

const LineGraph = (props) => {
  const criterionColorMap = {
    'warning': '#edb900',
    'danger': '#FF0000'
  }

  if (typeof props.criterion === 'undefined') {
    return null;
  }
  
  const criterion = props.criterion.map((data) => {
    if (data.standType === 'criterion') {
      return null; 
    }
  
    return {
      y: data.standVal,
      borderColor: criterionColorMap[data.standType],
      label: {
        borderColor: criterionColorMap[data.standType],
        style: {
          color: '#fff',
          fontSize: '9px',
          background: criterionColorMap[data.standType] + '35',
        },
        text: data.standName,
      }
    };
  });
  

  const config = {
    options: {
      chart: {
        id: props.graphId,
        type: 'line',
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
          },
        },
        animations: {
          enabled: false
        }
      },
      colors: ['#50bb5b'],
      annotations: {
        yaxis: criterion
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight',
        width: 2,
      },
      tooltip: {
        theme: 'dark',
        y: {
          title: {
            formatter: () => { return convertSubTagString(props.graphId === 'ch4' && props.flag === "0" ? 'CH4' : props.graphId.toUpperCase()) }
          }
        }
      },
      grid: {
        position: 'front',
        borderColor: '#90A4AE30',
      },
      yaxis: {
        tickAmount: lineGraphReferenceValue[props.graphId].tickAmount, // don't touch
        max: lineGraphReferenceValue[props.graphId].max, // don't touch
        min: lineGraphReferenceValue[props.graphId].min, // don't touch
        labels: {
          minWidth: 10,
          offsetY: 3,
          style: {
            colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
          }
        }
      },
      xaxis: {
        categories: props.categories,
        labels: {
          show: false,
          hideOverlappingLabels: true,
          style: {
            colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
            fontSize: '10px'
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    },
    series: [{
      name: "series-" + props.graphId,
      data: props.data
    }],
    
  }

  return (
    <>
      <div className="gasDetailGraph-title">{statusTypeStandardization(props.graphId, props.flag)}</div>
      <div className="gasDetailGraph-lineGraph">
        <Chart type="line" height="300" options={config.options} series={config.series}/>
      </div>
    </>
  )
}

export default LineGraph;